import get from 'lodash/get';


export const getBehaviors = state => get( getSelectedProgram( state ), 'behaviors', [] );
export const getEcards = state => get( getSelectedProgram( state ), 'ecards', [] );
export const getRewardChoices = state => get( state, 'programs.rewardChoices', [] );
export const getSelectedBehaviorId = state => get( state, 'programs.selectedBehavior', '' );
export const getSelectedProgram = state => get( state, 'programs.selectedProgram', {} );
export const getSelectedBehavior = state => {
    const selectedProgram = getSelectedProgram( state );
    if ( selectedProgram.behaviors && selectedProgram.behaviors.length > 0 && getSelectedBehaviorId( state ) )
    {
        return selectedProgram.behaviors.filter( behavior => {return getSelectedBehaviorId( state ) === behavior.id;} )[ 0 ];
    }
    return null;
};
